export enum Questionnaire {
    ESAS = 'esas';
}
